import { useEffect, useState } from 'react'

export enum ImgWithFallbackInit {
  Main,
  Fallback
}

export function useImgWithFallback(
  src,
  fallbackSrc,
  init: ImgWithFallbackInit = ImgWithFallbackInit.Main,
  loading = false
) {
  const [useFallback, setUseFallback] = useState(init === ImgWithFallbackInit.Fallback)

  useEffect(() => {
    if (loading) {
      return
    }
    let current = true
    const img = new Image()
    img.onload = () => {
      if (current) setUseFallback(false)
    }
    img.onerror = () => {
      if (current) setUseFallback(true)
    }
    img.src = src
    return () => {
      current = false
    }
  }, [src, loading])
  return useFallback ? fallbackSrc : src
}
